<template>
  <v-card>
    <s-crud
      :config="config"
      title="Categorización de Productores"
      :filter="filter"
      search-input
      ref="scrudProducerCategorization"
    >
      <template v-slot:filter>
        <v-container>
          <v-row style="margin-bottom: 5px">
            <v-col cols="12" md="3">
              <s-select-campaign-area
                label="Campaña"
                v-model="filter.CmaID"
                typeArea="1"
                clearable
              ></s-select-campaign-area>
            </v-col>

            <v-col cols="12" md="5">
              <s-select-producer
                label="Productor"
                v-model="filter.PrdID"
                clearable
              ></s-select-producer>
            </v-col>

            <v-col cols="12" md="2">
              <s-select
                label="Año"
                :items="years"
                v-model="filter.Year"
                clearable
              ></s-select>
            </v-col>

            <v-col cols="12" md="2">
              <s-periods
                v-if="filter.Year"
                label="Periodos"
                v-model="filter.PdsID"
                :year="filter.Year"
                :type="1"
                clearable
              ></s-periods>
              <div v-else style="padding-top: -2px; margin-top: -2px">
                <v-label><b>Periodos</b></v-label>
                <v-select
                  readonly
                  outlined
                  dense
                  placeholder="Seleccione año"
                  hide-details
                ></v-select>
              </div>
            </v-col>

            <v-col cols="12" md="2">
              <s-date
                label="Fecha Inicio"
                v-model="filter.BeginDate"
                clearable
              ></s-date>
            </v-col>

            <v-col cols="12" md="2">
              <s-date
                label="Fecha Fin"
                v-model="filter.EndDate"
                clearable
              ></s-date>
            </v-col>
          </v-row>
        </v-container>
      </template>

      <!-- Slot para mostrar el estado del contrato como un chip -->
      <template v-slot:StatusContractName="{ row }">
        <v-chip
          x-small
          class="font-weight-bold"
          :color="row.StatusContract == 1 ? 'success' : 'error'"
          dark
        >
          {{ row.StatusContractName }}
        </v-chip>
      </template>
    </s-crud>
  </v-card>
</template>

<script>
import TasProducerContractService from "../../../services/Technicalassistance/TasProducerContractService";
import sSelectProducer from "@/components/HarvestSchedule/SSelectProducer";
import SSelectCampaignArea from "@/components/Utils/SSelectCampaignArea.vue";
import SPeriods from "@/components/Utils/SPeriods.vue";

export default {
  name: "ProducerCategorization",
  components: {
    sSelectProducer,
    SSelectCampaignArea,
    SPeriods,
  },
  data() {
    return {
      filter: {
        CmaID: null,
        PrdID: null,
        PdsID: null,
        Year: null,
        BeginDate: null,
        EndDate: null,
      },
      years: [],

      config: {
        // Proxy para usar el método ProducerCategorization en lugar de pagination
        service: {
          pagination: (params, userId) => {
            // Si no hay campaña o se limpió el filtro, devolvemos vacío inmediatamente
            if (!params || !params.filter || !params.filter.CmaID) {
              return Promise.resolve({ data: { data: [], total: 0 } });
            }

            return TasProducerContractService.ProducerCategorization(
              {
                ...params,
                ...params.filter,
              },
              userId,
            ).then((response) => {
              // Inyectamos un ID virtual único usando el índice para evitar duplicados
              if (response.data && response.data.data) {
                response.data.data.forEach((item, index) => {
                  item.VirtualID = `${item.PrdCardName}_${item.CmaName}_${
                    item.Week || "N"
                  }_${index}`;
                  // Generamos el nombre legible del estado para el chip
                  item.StatusContractName =
                    item.StatusContract == 1 ? "Con Contrato" : "Sin Contrato";
                });
              }
              return response;
            });
          },
        },

        model: {
          VirtualID: "ID", // Usamos el ID virtual
          VolumeReceptionFresh: "decimal",
          VolumeDiscart: "decimal",
          VolumeContract: "decimal",
          CompliancePercentage: "decimal",
        },

        headers: [
          { text: "Productor", value: "PrdCardName" },
          { text: "Campaña", value: "CmaName" },
          { text: "Semana", value: "Week" },
          { text: "Estado Contrato", value: "StatusContractName" },
          {
            text: "Vol. Contrato - t",
            value: "VolumeContract",
            align: "right",
          },
          {
            text: "Vol. Recepcionado - t",
            value: "VolumeReceptionFresh",
            align: "right",
          },
          { text: "Vol. Descarte - t", value: "VolumeDiscart", align: "right" },
          {
            text: "Cant. Jabas Programadas",
            value: "QuantityHarvester",
            align: "right",
          },
          { text: "Cant. Jabas Reales", value: "QuantityReal", align: "right" },
          {
            text: "% Cumplimiento",
            value: "CompliancePercentage",
            align: "right",
          },
        ],
      },
    };
  },
  methods: {
    formatDate(date) {
      if (!date) return "";
      return this.$moment(date).format(
        this.$const.FormatDateView || "DD/MM/YYYY",
      );
    },
  },
  created() {
    this.years = [2025, 2026, 2027, 2028, 2029, 2030];
  },
};
</script>

<style scoped>
::v-deep .v-data-table > .v-data-table__wrapper > table > thead > tr > th {
  white-space: nowrap;
}

::v-deep .v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
  white-space: nowrap;
}
</style>
